/** Supabase Realtime env gate (testable via jest.mock) */
export function isSupabaseRealtimeAvailable(): boolean {
  const url = import.meta.env.VITE_SUPABASE_URL?.trim();
  const key = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();
  return Boolean(url && key);
}
